import { Component, Vue, Watch } from 'vue-property-decorator';
import AirPortTicketInfo from '../../../components/AirPortTicketInfo.vue';
import store from '@/store';
import router from '@/router';

// 注册组件路由守卫钩子
Component.registerHooks([
    'beforeRouteEnter',
]);

@Component({
    components: {
        AirPortTicketInfo,
    },
    filters: {
        Text(data: string) {
            const texts: any = {
                success: '预订成功',
                error: '预订失败',
            };
            return texts[data] || '';
        },
    },
})
export default class AuditReason extends Vue {
    private $api: any;
    private CurrentAirport: any;
    private status: string = '';
    private icons: any = {
        success: require('../../img/airticket/success.png'),
        auditSuccess: require('../../img/airticket/success.png'),
        wait: require('../../img/airticket/wait.png'),
        error: require('../../img/airticket/error.png'),
    };

    // 初始化
    private created() {
        this.CurrentAirport = JSON.parse(localStorage.getItem('CurrentAirport') || '');
    }

    private beforeRouteEnter(to: any, from: any, next: any) {
        if (store.state.AirTicketResult) {
            store.commit('resetAirTicketResult');
            next((vm: any) => {
                // 获取当前页面路由的后缀  'success' 'wait' 'error'
                vm.status = location.hash.split('-')[1];
            });
        } else {
            router.go(1);
        }
    }

    private getTips(status: string) {
        const tips: any = {
            success: '请合理安排行程，避免延误哦！',
            wait: '您的机票预订信息已提交',
            error: store.state.AirTicketSubmitError || '可能是系统接口问题或网络故障，<br/>请重新订票或待会儿再试',
            auditSuccess: '退票成功',
        };
        return tips[status] || '';
    }

    private back() {
        this.$router.push('/tripinfo-list');
    }

    
}
